module.exports = __webpack_public_path__ + "02_2x.jpg?f392d2c95053daa570876ecef1fdbbf0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/02_2x.jpg
// module id = 13
// module chunks = 0